import React from 'react';
import PropTypes from 'prop-types';
import ModalWindow from '../../common/Modal';
import AccountIdConfigModalForm from './Form/Form';

function AccountIdConfigModal(props) {
  const { onClose, retailer, onSave, accountIdConfig, open = false } = props;
  const closeModal = () => {
    onClose(false);
  };

  return (
    <ModalWindow open={open} onClose={closeModal} showCloseIcon={true} size="large" center>
      <h2>Account ID Settings</h2>
      <p>Set the account id of {retailer.retailer_name} in your internal system</p>
      <hr />
      <AccountIdConfigModalForm props={props} onSave={onSave} accountIdConfig={accountIdConfig} />
    </ModalWindow>
  );
}

export default AccountIdConfigModal;

AccountIdConfigModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  retailerName: PropTypes.string,
};
